import type { CSSProperties } from 'react';
import React, { useContext, useMemo, useRef } from 'react';
import type { RadioState } from './context';
import { RadioContext } from './context';

interface Props<T> {
  children?: React.ReactNode;
  className?: string;
  selectedValue?: T;
  style?: CSSProperties;

  onChangeSelected?: (value: T) => unknown;
}

let counter = 0;

const RadioGroup = <T,>({
  children,
  className,
  selectedValue,
  style,
  onChangeSelected,
}: React.PropsWithChildren<Props<T>>) => {
  const instanceId = useRef(counter++);
  const parentContext = useContext(RadioContext);
  const state = useMemo<RadioState<T>>(
    () => ({
      groupName: `${parentContext?.groupName ?? ''}RadioGroup-${instanceId.current}`,
      selectedValue,
      onChangeSelected,
    }),
    [parentContext?.groupName, selectedValue, onChangeSelected]
  );

  return (
    <RadioContext.Provider value={state}>
      <div className={className} style={style}>
        {children}
      </div>
    </RadioContext.Provider>
  );
};

export default RadioGroup;
